var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmptyRecommendationRun(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2351 2.28759C14.5424 2.38902 14.75 2.67616 14.75 2.99981V9.44981H18C18.2833 9.44981 18.5424 9.60941 18.6698 9.8624C18.7973 10.1154 18.7713 10.4186 18.6027 10.6462L10.6027 21.4462C10.41 21.7063 10.0723 21.8135 9.76495 21.712C9.45761 21.6106 9.25 21.3235 9.25 20.9998V14.5498H6C5.71673 14.5498 5.45762 14.3902 5.33018 14.1372C5.20275 13.8842 5.22872 13.581 5.39734 13.3534L13.3973 2.55338C13.59 2.29332 13.9277 2.18616 14.2351 2.28759ZM7.48891 13.0498H10C10.4142 13.0498 10.75 13.3856 10.75 13.7998V18.7273L16.5111 10.9498H14C13.5858 10.9498 13.25 10.614 13.25 10.1998V5.27233L7.48891 13.0498Z",
    fill: "#A3B0C2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyRecommendationRun);
export default __webpack_public_path__ + "static/media/empty-recommendationRun.aebe7e369d3622864159c0f6bef01690.svg";
export { ForwardRef as ReactComponent };